// extracted by mini-css-extract-plugin
export var emailBlockLink = "_p9-0";